import { P as e } from "./index-057d60ee.js";
const o = e.oneOfType([e.func, e.object]), r = o;
export {
  r
};
//# sourceMappingURL=refType-35cf7811.js.map
